import { Injectable, inject } from '@angular/core';
import {Observable} from "rxjs";
import {SessionService} from "@core";
import {HttpClient} from "@angular/common/http";
import {BaseResult} from "@shared";
import {IssueReport} from "../models/issue-report.model";

@Injectable({
    providedIn: 'root'
})
export class IssueReportService {
    private readonly sessionService = inject(SessionService);
    private readonly httpClient = inject(HttpClient);


    public sendIssueReport(reportContent: IssueReport): Observable<BaseResult> {
        const url = `${this.sessionService.getApiUrl()}/report_issue/${this.sessionService.requestId}`;
        const body = {
            content: reportContent.content,
            jobId: reportContent.jobId
        };
        return this.httpClient.post<BaseResult>(url, body, {});
    }
}
